<template>
  <div class="register-page">
    <div>
      <van-nav-bar
        title="用户注册"
        left-text="返回"
        right-text=""
        left-arrow
        @click-left="onTopClickLeft"
        class="custom-nav-bar"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>

    <div class="register-container">
      <!-- Logo 和品牌区域 -->
      <div class="brand-section">
        <div class="logo-wrapper">
          <img
            src="https://www.ptty.com.cn/wap/logo.png"
            alt="跑兔体育"
            class="brand-logo"
          />
        </div>
        <div class="brand-name">跑兔体育</div>
        <div class="brand-slogan">专业的体育赛事服务平台</div>
      </div>

      <div class="register-card">
        <div class="register-title">用户注册</div>

        <div class="form-section">
          <div class="form-item">
            <van-field
              v-model="ryInfo.NIC"
              label="昵称"
              placeholder="请输入昵称"
              class="register-field"
            />
          </div>
          <div class="form-item">
            <van-field
              v-model="ryInfo.TEL"
              label="手机号"
              placeholder="请输入手机号"
              class="register-field"
            />
          </div>
          <div class="form-item gender-item">
            <van-row>
              <van-col span="8">
                <span class="gender-label">性别</span>
              </van-col>
              <van-col span="16">
                <van-radio-group v-model="ryInfo.XB" direction="horizontal">
                  <van-radio name="M">男</van-radio>
                  <van-radio name="W">女</van-radio>
                </van-radio-group>
              </van-col>
            </van-row>
          </div>
          <div class="form-item">
            <van-field
              v-model="ryInfo.PWD1"
              label="密码"
              type="password"
              placeholder="请输入密码"
              class="register-field"
            />
          </div>
          <div class="form-item">
            <van-field
              v-model="ryInfo.PWD2"
              label="确认密码"
              type="password"
              placeholder="请确认密码"
              class="register-field"
            />
          </div>
        </div>

        <div
          class="button-section"
          v-if="ryInfo.openIdEn && ryInfo.openIdEn.length > 0"
        >
          <van-button
            type="primary"
            block
            @click="registerHandler"
            class="register-btn"
          >
            快速注册
          </van-button>
        </div>
      </div>
    </div>

    <loading-com />
  </div>
</template>

<script>
import HeaderCom from "./../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import md5 from "js-md5";
export default {
  components: { HeaderCom, LoadingCom, md5 },
  name: "RegisterIndex",

  data() {
    return {
      ryInfo: {
        NIC: "",
        TEL: "",
        TELEN: "",
        XB: "M",
        PWD1: "",
        PWD2: "",
        isLogin: false,
        openIdEn: "",
        routeValue: ""
      }
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    var openIdEn = this.$route.query.openIdEn;
    if (
      openIdEn === undefined ||
      openIdEn === null ||
      openIdEn.length === 0 ||
      openIdEn === "465255654578797a502b303d"
    ) {
      var that = this;
      this.utilPost.getOpenId(function(openId) {
        that.ryInfo.openIdEn = openId;
      });
    } else {
      this.ryInfo.openIdEn = openIdEn;
    }
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
  },
  methods: {
    onTopClickLeft() {
      this.$router.go(-1);
    },

    registerHandler() {
      var openIdEn = this.ryInfo.openIdEn;
      if (
        openIdEn === undefined ||
        openIdEn === null ||
        openIdEn.length === 0 ||
        openIdEn === "465255654578797a502b303d"
      ) {
        this.$notify({
          type: "danger",
          message: "注册失败，openId获取失败，请关闭网页重新进入",
          duration: 6000
        });
        return;
      }
      var ryInfo = this.ryInfo;
      if (
        ryInfo.NIC.length === 0 ||
        ryInfo.TEL.length === 0 ||
        ryInfo.XB.length === 0 ||
        ryInfo.PWD1.length === 0 ||
        ryInfo.PWD2.length === 0
      ) {
        alert("所有项必填");
        return;
      }
      ryInfo.PWD1 = md5(ryInfo.PWD1);
      ryInfo.PWD2 = md5(ryInfo.PWD2);
      if (ryInfo.PWD1 !== ryInfo.PWD2) {
        alert("密码不一致，请检查");
        return;
      }
      if (!confirm("是否注册?")) {
        return;
      }
      var busData = {
        ryInfo: ryInfo
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "register" //对应的方法名
        },
        busData: busData //参数内容
      };
      // alert(JSON.stringify(paramData));
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          this.$notify({
            type: "danger",
            message: "注册失败，系统检测手机号已经注册",
            duration: 6000
          });
          return;
        }
        this.$notify({
          type: "success",
          message: "注册成功",
          duration: 6000
        });
        localStorage.setItem("ryInfo", "");
        localStorage.setItem("openIdEn", "");

        // 注册成功后的跳转逻辑
        this.redirectAfterRegister();
      });
    },

    // 注册成功后的跳转逻辑
    redirectAfterRegister() {
      // 优先使用 localStorage 中保存的上一个路由
      const previousRoute = localStorage.getItem("previousRoute");
      if (
        previousRoute &&
        previousRoute !== "/loginIndex" &&
        previousRoute !== "/registerIndex"
      ) {
        // 有上一个路由且不是登录/注册页，跳转回去
        localStorage.removeItem("previousRoute"); // 清除已使用的路由
        this.$router.replace(previousRoute);
      } else {
        // 默认跳转到首页
        const routeValue = localStorage.getItem("routeValue");
        if (routeValue) {
          this.$router.replace("/" + routeValue);
        } else {
          this.$router.replace("/");
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/* 字体渲染优化 */
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 页面容器 */
.register-page {
  min-height: 100vh;
  background: #f5f6fa;
}

/* 导航栏 */
.custom-nav-bar {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);

  /deep/ .van-nav-bar__title {
    color: #fff;
    font-weight: 700;
    font-size: 1.125rem;
  }

  /deep/ .van-nav-bar__text,
  /deep/ .van-icon {
    color: #fff;
  }
}

/* 注册容器 */
.register-container {
  padding: 2rem 1rem 3rem;
}

/* Logo 和品牌区域 */
.brand-section {
  text-align: center;
  margin-bottom: 2rem;
}

.logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.brand-logo {
  width: 5rem;
  height: 5rem;
  object-fit: contain;
  animation: logoFadeIn 0.8s ease;
}

@keyframes logoFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.brand-name {
  font-size: 1.75rem;
  font-weight: 700;
  color: #185f9b;
  margin-bottom: 0.5rem;
  letter-spacing: 2px;
  animation: slideDown 0.6s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.brand-slogan {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  animation: fadeIn 0.8s ease 0.2s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 注册卡片 */
.register-card {
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.875rem;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.15);
  animation: cardSlideUp 0.6s ease 0.3s both;
}

@keyframes cardSlideUp {
  from {
    opacity: 0;
    transform: translateY(1.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 注册标题 */
.register-title {
  padding: 0.5rem 0 1rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 700;
  color: #333;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 1.5rem;
}

/* 表单区域 */
.form-section {
  margin-bottom: 1rem;
}

.form-item {
  margin-bottom: 1rem;
}

/* 注册字段 */
.register-field {
  border-radius: 0.5rem;
  overflow: hidden;

  /deep/ .van-field__label {
    font-size: 1rem;
    color: #6b7280;
    font-weight: 500;
  }

  /deep/ .van-field__control {
    color: #1f2937;
    font-weight: 500;
  }
}

/* 性别选择 */
.gender-item {
  padding: 0.75rem 1rem;
  background: #f9fafb;
  border-radius: 0.5rem;
}

.gender-label {
  font-size: 1rem;
  color: #6b7280;
  font-weight: 500;
}

/deep/ .van-radio-group {
  display: flex;
  gap: 1.5rem;
}

/deep/ .van-radio {
  font-size: 1rem;
}

/deep/ .van-radio__icon--checked .van-icon {
  background-color: #185f9b;
  border-color: #185f9b;
}

/* 按钮区域 */
.button-section {
  margin-top: 1.5rem;
}

/* 注册按钮 */
.register-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
  font-weight: 600;
  font-size: 1rem;
  height: 2.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);

  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginIndex/RegisterIndex.vue